<template>
  <div class="students">
    <div
      v-for="student in sortedStudents"
      :key="student.id"
      :class="STUDENT_STATUS[student.status]"
      class="student">
        <div class="name">
          {{ fullName(student) }}
        </div>
        <div class="status">
          {{ $t(`status.${STUDENT_STATUS[student.status]}`) }}
          <span v-if="student.status === PREPARING">
            {{ timeSince(student.status_changed_time) }} {{ $t('exam.TIME_UNIT') }}
          </span>
        </div>

        <div
          v-if="student.examination_paper"
          class="examinationPaper">
            {{ $t('exam.PAPER') }} #{{ paperNumber(student) }}
        </div>

        <div class="controls">
          <template v-if="student.status === AWAITING_PAPER">
            <a href=""
              @click.prevent="sendPaper(student.id)">
                {{ $t('exam.action.GIVE_PAPER') }}
            </a>
          </template>

          <template v-if="student.status === PREPARING || student.status === READY">
            <a href=""
              @click.prevent="updateStatus({
                studentId: student.id,
                status: STARTED
              })">
                {{ $t('exam.action.INVITE_STUDENT') }}
            </a>
          </template>

          <template v-if="student.status === STARTED">
            <a href=""
              @click.prevent="updateStatus({
                studentId: student.id,
                status: PREPARING
              })">
                {{ $t('exam.action.REVERT_STUDENT_SHORT') }}
            </a>
            <a href=""
              @click.prevent="updateStatus({
                studentId: student.id,
                status: FINISHED
              })">
                {{ $t('exam.action.FINISH_SHORT') }}
            </a>
          </template>
        </div>
    </div>
  </div>
</template>

<script>
import {
  STARTED,
  AWAITING_PAPER,
  PREPARING,
  READY,
  FINISHED,
  STUDENT_STATUS
} from '@/config'

import { date2local, fullName } from '@/utils/utils.format'

export default {
  name: 'StudentList',
  props: {
    students: Array,
    getPaper: Function,
    sendPaper: Function,
    updateStatus: Function
  },
  data () {
    return {
      STARTED,
      AWAITING_PAPER,
      PREPARING,
      READY,
      FINISHED,
      STUDENT_STATUS,
    }
  },
  computed: {
    sortedStudents () {
      return [...this.students]
        .sort(({ status: a }, { status: b }) =>
          b - a)
    }
  },
  methods: {
    fullName,
    date2local,
    timeSince (statusChanged) {
      const delta = new Date() - new Date(statusChanged)
      const deltaMinute = Math.floor(delta / 1000 / 60)
      if (deltaMinute < 1) {
        return '<1'
      }
      return deltaMinute
    },
    paperNumber (student) {
      return this.getPaper(student.examination_paper)?.number
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/base.scss";

.students {
  line-height: 24px;

  .student {
    margin-bottom: 8px;
    border-left: 4px solid;
    padding-left: 12px;

    // &.NOT_STARTED  { border-color: #808080; }
    &.NOT_STARTED  { border-color: $text-secondary; }
    &.AWAITING_PAPER { border-color: $main-light; }
    &.PREPARING    { border-color: $main-medium; }
    &.READY        { border-color: $main-high; }
    &.STARTED      { border-color: $accent; }
    &.FINISHED     { border-color: $text-main; }

    .status {
      color: $text-secondary;
    }

    &:hover .controls,
    &:focus-within .controls {
      color: $accent;
    }
    .controls {
      color: $main-medium;

      a {
        margin-right: 8px;
      }
    }
  }
}

</style>
